export * from "./favorites-empty.component";
